import {Action, Dispatch} from 'redux';
import {CreatePolicy, InsurePolicy, InsurerId, SortBy, UpdateDocument} from '../../Config/dataModel';
import policyAPI from '../APIs/policyAPI';

const TYPES = {
    FETCH_ALL_POLICIES_SUCCESS: 'FETCH_ALL_POLICIES_SUCCESS',
    FETCH_POLICY_COUNT_SUCCESS: 'FETCH_POLICY_COUNT_SUCCESS',
    IN_APPLY_POLICY_SUCCESS: 'IN_APPLY_POLICY_SUCCESS',
    IN_INSURE_POLICY_SUCCESS: 'IN_INSURE_POLICY_SUCCESS',
    UPDATE_POLICY_SUCCESS: 'UPDATE_POLICY_SUCCESS'
};

const fetchAllPolicies = (data: SortBy) => {
    return function (dispatch: Dispatch<Action>) {
        return policyAPI.allPolicies(data).then(res => {
            dispatch(storeAllPolicies(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchPolicyCount = (data: InsurerId) => {
    return function (dispatch: Dispatch<Action>) {
        return policyAPI.policyCount(data).then(res => {
            dispatch(storePolicyCount(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const insurerApplyPY = (data: CreatePolicy) => {
    return function (dispatch: Dispatch<Action>) {
        return policyAPI.insurerApplyPY(data).then(res => {
            dispatch(storeInsurerApplyPYStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const insurerInsurePY = (ref: string, data: InsurePolicy) => {
    return function (dispatch: Dispatch<Action>) {
        return policyAPI.insurerInsurePY(ref, data).then(res => {
            dispatch(storeInsurerInsurePYStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const updatePolicy = (ref: string, data: UpdateDocument) => {
    return function (dispatch: Dispatch<Action>) {
        return policyAPI.updatePolicy(ref, data).then(res => {
            dispatch(storeUpdatePYStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const storeAllPolicies = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_POLICIES_SUCCESS,
        allPolicies: data
    };
};

const storePolicyCount = (data: object) => {
    return {
        type: TYPES.FETCH_POLICY_COUNT_SUCCESS,
        policyCount: data
    };
};

const storeInsurerApplyPYStatus = (data: object) => {
    return {
        type: TYPES.IN_APPLY_POLICY_SUCCESS,
        pySummary: data
    };
};

const storeInsurerInsurePYStatus = (data: object) => {
    return {
        type: TYPES.IN_INSURE_POLICY_SUCCESS,
        pySummary: data
    };
};

const storeUpdatePYStatus = (data: object) => {
    return {
        type: TYPES.UPDATE_POLICY_SUCCESS,
        pySummary: data
    };
};

export {TYPES, fetchAllPolicies, fetchPolicyCount, insurerApplyPY, insurerInsurePY, updatePolicy};


// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/policyAction.ts